import request from './request';

/**
 * 分析API - V2
 */

// 获取总览分析
export function getOverviewAnalysis(params) {
  return request({
    url: '/eval/analysis/overview',
    method: 'get',
    params
  });
}

// 获取分析总览（别名）
export function getAnalysisOverview(params) {
  return request({
    url: '/eval/analysis/overview',
    method: 'get',
    params
  });
}

// 获取测试用例分析
export function getTestCaseAnalysis(id) {
  return request({
    url: `/eval/analysis/test-case/${id}`,
    method: 'get'
  });
}

// 获取测试计划分析
export function getTestPlanAnalysis(id) {
  return request({
    url: `/eval/analysis/test-plan/${id}`,
    method: 'get'
  });
}

// 获取对比分析
export function getComparisonAnalysis(type, id1, id2) {
  return request({
    url: '/eval/analysis/comparison',
    method: 'get',
    params: { type, id1, id2 }
  });
}

// 获取覆盖率分析
export function getCoverageAnalysis() {
  return request({
    url: '/eval/analysis/coverage',
    method: 'get'
  });
}

// 获取用例性能分析
export function getCasePerformance(caseId) {
  return request({
    url: `/eval/analysis/case-performance/${caseId}`,
    method: 'get'
  });
}

// 获取快照对比分析
export function getSnapshotComparison(snapshotId1, snapshotId2) {
  return request({
    url: '/eval/analysis/snapshot-comparison',
    method: 'get',
    params: { 
      snapshot_id_1: snapshotId1, 
      snapshot_id_2: snapshotId2 
    }
  });
}

// 获取测试用例的快照列表（用于分析报告）
export function getTestCaseSnapshots(testCaseId) {
  return request({
    url: `/eval/snapshots/test-case/${testCaseId}`,
    method: 'get'
  });
}

